import {fetchVolumeReport} from '../services/reportService';
import moment from 'moment';
type Period = 'default' | '2Y' | '1Y' | '6M' | '3M' | '1M' | '1W';
export function getVolumeReport(period: Period, symbol: string) {
    let endDate = moment().format('YYYY-MM-DD');
    let startDate: string;
    console.log("getReport period:", period);
    console.log("getReport symbol:", symbol);
  switch (period) {
    case '2Y':
        startDate = moment().subtract(2, 'years').format('YYYY-MM-DD');
        break;
      case '1Y':
        startDate = moment().subtract(1, 'years').format('YYYY-MM-DD');
        break;
      case '6M':
        startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
        break;
      case '3M':
        startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
        break;
      case '1M':
        startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
        break;
      case '1W':
        startDate = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
        break;
      default:
        startDate = '';
        endDate = '';
        break;
      }
return (dispatch: any) => {
    fetchVolumeReport(symbol, startDate, endDate).then((data) => { 
        dispatch({type:'RECEIVE_VOLUME_REPORT', report: data, loading:false});
     }).catch((err) => {
        console.error('Failed to load report:', err);
        dispatch({type:'RECEIVE_VOLUME_REPORT', report: [], loading: true});
    });
    };
}

export function setVolumeReportLoading(loading: boolean) {
  console.log("setReportLoading:", loading);
  return (dispatch: any)=>{
      dispatch({type:'SET_VOLUME_REPORT_LOADING', loading: loading});
  };
}